import React from 'react';
import { DatoCmsFaqList } from '../../../schema/datocms';
import { Alignments } from '../../../schema/enum/alignments';
import { buildQuestionListItem, getColumnSpanClass, getColumnStartClass, getTextAlignmentClass } from '../../../utilities';
import HtmlEntityTextComponent from '../../html-entity-text/html-entity-text-component';
import { useThemeClassMap } from '../../theme/useThemeClassMap';

const FaqListComponent = (
    {
        columnLayout, theme, faqGroup
    }: DatoCmsFaqList
): React.ReactElement => {
    const themeClass = useThemeClassMap(theme);

    const gridColumnSpanClass: string = getColumnSpanClass(columnLayout);
    const gridColumnStartClass: string = getColumnStartClass(columnLayout);

    return (
        <div className={`${ themeClass } py-8`}>
            <div className="container mx-auto lg:grid lg:grid-cols-12">
                <div className={`lg:${gridColumnSpanClass} lg:${gridColumnStartClass}`}>
                    { faqGroup && <h2 className={`${getTextAlignmentClass(Alignments.LEFT)}`}>
                        { <HtmlEntityTextComponent text={faqGroup.name} /> || faqGroup.name }
                    </h2> }
                    <ul className="pt-4 flex flex-col space-y-2">
                        {
                            faqGroup.questions.map((faq, index) => buildQuestionListItem(index, faqGroup.name, faq.question))
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default FaqListComponent;
